export enum CustomerCreationSource {
    onlineBooking = 'ONLINE_BOOKING',
}